import { Button, Search } from '@ibsys/kit';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useHasPermission } from '@/entities/profile';
import { useAppNavigate } from '@/shared/lib';
import { useFormGuardActions } from '@/entities/formGuard';
import { UsersGroupsCard } from './ui/UsersGroupsCard/UsersGroupsCard';
import { UsersGroupsList } from './ui/UsersGroupsList/UsersGroupsList';
import { MasterDetailLayout } from '@/shared/ui';

export const UserGroupsPage: FC = () => {
  const { t } = useTranslation(['common', 'users']);

  const { id: idOrCreating } = useParams<{ id?: string }>();
  const isCreating = idOrCreating === 'create';
  const id = idOrCreating && !isCreating ? +idOrCreating : undefined;

  const navigate = useAppNavigate();
  const canEdit = useHasPermission('ADMIN_USER_GROUP');
  const hasDevelopment = useHasPermission('DEVELOPMENT');
  const { setIsDirty } = useFormGuardActions();

  const handleClickAdd = () => {
    navigate('/user-groups/create');
  };

  const handleBack = () => {
    navigate('/user-groups');
  };

  return (
    <MasterDetailLayout
      isDetailOpen={Boolean(idOrCreating)}
      onBack={handleBack}
      toolbar={
        <div className="flex w-full items-center gap-4">
          {hasDevelopment && (
            <>
              <Search className="flex-1" placeholder={t('search')} />
              <Button variant="outline">{t('search')}</Button>
            </>
          )}
          {canEdit && (
            <Button onClick={handleClickAdd} className="ml-auto">
              {t('users:addGroup')}
            </Button>
          )}
        </div>
      }
      list={<UsersGroupsList />}
      detail={
        <UsersGroupsCard groupId={id} isCreating={isCreating} key={id} onUnsavedChange={(dirty) => setIsDirty(dirty)} />
      }
      empty={
        <div className="flex items-center justify-center h-full text-muted-foreground">
          {t('users:selectUserGroup')}
        </div>
      }
    />
  );
};
